import {HttpModelConverter} from '../../../../core/converter/httpModel.converter';
import {Injectable} from '@angular/core';
import {InsoleCadProcessModel} from './insoleCadProcess.model';
import {InsoleCadProcessSummaryConverter} from './insoleCadProcessSummary.converter';
import {InsolesSummaryConverter} from '../../../insoles/api/model/insolesSummary.converter';

@Injectable({
    providedIn: 'root'
})
export class InsoleCadProcessConverter extends HttpModelConverter<InsoleCadProcessModel> {
    constructor(private cadProcessSummaryConverter: InsoleCadProcessSummaryConverter,
                private insolesSummaryConverter: InsolesSummaryConverter) {
        super();
    }
    protected createInstance(): InsoleCadProcessModel {
        return new InsoleCadProcessModel();
    }

    protected enrichObject(result: InsoleCadProcessModel, src: InsoleCadProcessModel) {
        result.summary = this.cadProcessSummaryConverter.convert(src.summary);
        result.insoles = this.insolesSummaryConverter.convert(src.insoles);
    }
}
